export enum ButtonSize {
    XSmall = 'xs',
    Small = 'sm',
    Medium = 'md',
    Large = 'lg',
    XLarge = 'xl',
    XXLarge = '2xl'
}